import {useCallback, useState} from "react";
import {deleteAutoCheckInConfig, updateAutoCheckInConfig} from "./api";
import {AutoCheckInConfigUpdateRequest} from "./types";

export function useDeleteCheckInConfig(profileID: string | undefined, refetchProfiles: () => void) {

    const [error, setError] = useState<string>()
    const [message, setMessage] = useState<string>()
    const [name, setName] = useState("")
    const [submitting, setSubmitting] = useState<boolean>()

    const submit = useCallback(async () => {
        setMessage(undefined)
        if(!profileID){
            setError("no profile selected")
            return false
        }
        setError(undefined)
        setSubmitting(true)

        const result = await deleteAutoCheckInConfig(profileID)

        result.match(
            () => {
                setMessage("profile deleted")
                refetchProfiles()
            },
            (err) => setError(err.message)
        )

        setSubmitting(false)

        return result.isOk()
    }, [profileID, refetchProfiles])

    return {submit, submitting, error, name, setName, message}

}